import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {getAliasName, isDeepModel} from '../../models/llm/llm';
import {StepConfig} from '../../models/convo';


@Component({
  selector: 'moti-alias-label',
  templateUrl: './alias-label.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './alias-label.component.scss',
})
export class AliasLabelComponent {
  @Input() config: StepConfig;

  protected readonly getAliasName = getAliasName;
  protected readonly isDeepModel = isDeepModel;
}
